```vue
<template>
  <button class="special-action-button" v-bind="$attrs" v-on="$listeners">
    <span class="content">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  name: 'SpecialActionButton',
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;

@keyframes grad-rotate {
  to {
    transform: rotate(360deg);
  }
}

.special-action-button {
  font-family: $font-family;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  isolation: isolate;
  overflow: hidden;
  background: transparent;
  transition: transform 0.2s ease, filter 0.2s ease;
  padding: 8px 12px;
  margin: 0;
}

/* spinning fill */
.special-action-button::before {
  content: '';
  position: absolute;
  width: 150%;
  aspect-ratio: 1 / 1;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  z-index: -1;
  background: linear-gradient(92.41deg, #2B9EC6 20.45%, #A4CE3A 103.04%);
  animation: grad-rotate 6s linear infinite;
  transform-origin: center center;
}

/* gradient border */
.special-action-button::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: 4px;
  padding: 1px;
  background: linear-gradient(88.79deg, #A7DAEC 0.69%, #D2E69D 98.96%);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
          mask-composite: exclude;
  pointer-events: none;
}

.content {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.special-action-button:hover {
  transform: translateY(-2px);
  filter: brightness(1.06);
}

.special-action-button:active {
  transform: translateY(0);
  filter: brightness(0.96);
}
</style>
```